const productStrategyManifest = {
  featureId: "product_strategy_view",
  serviceKey: "product_strategy",
  name: "Product Strategy",
  description:
    "Generate design hypotheses, identify customer goals, pain points, and formulate competitive UX positioning",
  mode: "workflow",

  steps: [
    {
      id: "brief_deconstruction",
      title: "Mapping What's Solid vs Assumed",
      description:
        "Assessing what's known, what's assumed, and what decisions can be made now",
      status: "pending",
      agentKey: "DESIGN_LEAD",
      estimatedDuration: 60,
      loadingMessages: [
        "Analyzing your design challenge...",
        "Extracting key problem dimensions...",
        "Identifying stakeholders and constraints...",
        "Synthesizing challenge context...",
        "Structuring your brief elements...",
      ],
    },
    {
      id: "market_scan",
      title: "Market & Audience Signals",
      description:
        "Quick market scan to gather competitive signals and validate opportunity areas",
      status: "pending",
      agentKey: "UX_RESEARCH",
      estimatedDuration: 30,
      loadingMessages: [
        "Scanning market landscape...",
        "Gathering competitive signals...",
        "Analyzing audience patterns...",
        "Identifying market opportunities...",
        "Validating opportunity areas...",
      ],
    },
    {
      id: "design_hypothesis",
      title: "Building Your Strategy Blueprint",
      description: "Formulating design hypotheses and strategic positioning",
      status: "pending",
      agentKey: "DESIGN_LEAD",
      estimatedDuration: 90,
      loadingMessages: [
        "Formulating design hypotheses...",
        "Crafting experience principles...",
        "Defining success metrics...",
        "Developing strategic themes...",
        "Building your strategy blueprint...",
      ],
    },
  ],

  outputs: [
    "brief_deconstruction",
    "audience_insights",
    "design_hypotheses",
    "strategic_themes",
    "opportunity_areas",
    "success_metrics",
  ],

  intro: "🚀 Creating your Product Strategy...",
  completion:
    "✅ **Product Strategy Ready!** Your strategic blueprint has been created.",
};

module.exports = productStrategyManifest;
